import React, {Component} from 'react';
import Modal from 'react-responsive-modal';

const closeSvg = <path
    d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"/>
const ModalInPerson = ({open = false, handleClose, handleOk}) => {

    return (
        <Modal open={open} onClose={handleClose} closeIconSvgPath={closeSvg} center={true}>
            <div className="col-md-12">
                <span className="h2 m20 ml10 mb10">Enviar a Presencial</span>
                <div className="text-md--light m10">
                    ¿Está seguro que desea cambiar el estado de esta inspección de "Devuelto" a "Presencial"?
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <button type="button" className="btn btn-outline-secondary mr10"
                                onClick={handleClose}>Cancelar
                        </button>
                        <button type="button" className="btn btn-primary" onClick={handleOk}>Confirmar</button>
                    </div>
                </div>
            </div>

        </Modal>
    );
};
export default ModalInPerson;



// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspection/components/inPerson/modal-in-person.js